import { FieldDef } from '@core/models/account.types';
import { CustomObject } from './custom-objects.types';

/**
 * @param field - The fieldDef to check.
 * @returns True if the field is the one created by the BE from adding a relationship, false otherwise.
 */
const hasLinkedField = (field: FieldDef): boolean => {
  return (
    field.name.startsWith('cf_linked_') &&
    field.type === 'record' &&
    !field.created_by_id &&
    !field.created_by_user_name
  );
};

/**
 * @param customObject - The customObject to check.
 * @param contextType - The type of the context (e.g. 'Company', 'Contact', 'Project', 'Property').
 * @returns True if the customObject has a archived linked field that matches the context type, false otherwise.
 */
const hideCustomObjectTabBasedOnArchivedLinkedField = (customObject: CustomObject, contextType: string): boolean => {
  const fields = customObject.custom_fields || customObject.fields;
  return fields.some((field) => hasLinkedField(field) && field.archived && field.meta.record_type === contextType);
};

export { hasLinkedField, hideCustomObjectTabBasedOnArchivedLinkedField };
